import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { IClippingStudioRepository } from "app/js/src/domain/clipping-studio/i-clipping-studio-repository";
import { PublishingRepository } from "app/js/src/infrastructure/repositories/publishing-status/publishing.repository";

@Injectable({ providedIn: "root" })
export class ClippingStudioNavigationService {
  constructor(
    private readonly router: Router,
    private readonly repository: IClippingStudioRepository,
    private readonly publicationsRepository: PublishingRepository,
  ) {}

  /**
   * Creates a new project + draft publication and navigates to the studio editor.
   * The editor loads project data via GET /api/publications/{publicationUid}/open.
   */
  async openNewProjectForMedia(mediaId: number): Promise<void> {
    const createResult = await this.repository.createNewProject(mediaId);
    await this.openPublicationEditor(createResult.publicationUid);
  }

  /**
   * Opens an existing draft publication in the studio editor.
   * Project data is loaded via GET /api/publications/{publicationUid}/open.
   */
  async openPublicationEditor(publicationUid: string): Promise<void> {
    await this.router.navigate(["/clipping-studio", publicationUid, "edit"]);
  }

  /**
   * Forks a non-draft publication (POST re-edit), then opens the new draft in the studio.
   */
  async reEditPublication(sourcePublicationUid: string): Promise<void> {
    const result =
      await this.publicationsRepository.reEditPublication(sourcePublicationUid);
    await this.openPublicationEditor(result.publicationUid);
  }
}
